import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AppMaterialModule } from '@app/app-material.module';
import { ComponentsModule } from '@shared/components/components.module';
import { AnimationsModule } from '@shared/animations/animations.module';
import { ServicoExecutadoController } from '@modules/servicos-executados/controllers';
import { ServicosExecutadosComponent } from '@modules/servicos-executados/pages/servicos-executados/servicos-executados.component';
import { DetalhesServicoExecutadoComponent } from '@app/modules/servicos-executados/components/detalhes-servico-executado/detalhes-servico-executado.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [ServicosExecutadosComponent, DetalhesServicoExecutadoComponent],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [provideNgxMask(maskConfig), ServicoExecutadoController],
})
export class ServicosExecutadosModule {}
